module.exports = __webpack_public_path__ + "img/bg_mob-old.c733b973.png";